import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AusstallenFrageDialogComponent } from './ausstallen-frage-dialog/ausstallen-frage-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { DialogsModule } from '../dialogs/dialogs.module';
import { TierlisteImportierenFrageDialogComponent } from './tierliste-importieren-frage-dialog/tierliste-importieren-frage-dialog.component';
import { AusstallenDialogComponent } from './ausstallen-dialog/ausstallen-dialog.component';
import { AusstallenEmpfaengerDialogComponent } from './ausstallen-empfaenger-dialog/ausstallen-empfaenger-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MeineKontakteModule } from '../meine-kontakte/meine-kontakte.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { DirectivesModule } from '../../directives/directives.module';
import { TierlisteSchlachthofAuswahlDialogComponent } from './tierliste-schlachthof-auswahl-dialog/tierliste-schlachthof-auswahl-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { BetriebskontaktAuswahlModule } from '../stammdaten/betriebskontakte/betriebskontakt-auswahl.module';
import { BetriebskontaktCardModule } from '../stammdaten/betriebskontakte/betriebskontakt-card.module';
import { GruppeTierModule } from '../gruppe-tier/gruppe-tier.module';

@NgModule({
    declarations: [
        AusstallenFrageDialogComponent,
        TierlisteImportierenFrageDialogComponent,
        AusstallenDialogComponent,
        AusstallenEmpfaengerDialogComponent,
        TierlisteSchlachthofAuswahlDialogComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatRadioModule,
        MatCheckboxModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        DialogsModule,
        MeineKontakteModule,
        MatDatepickerModule,
        MatIconModule,
        MatInputModule,
        MatCardModule,
        MatDividerModule,
        DirectivesModule,
        MatSelectModule,
        BetriebskontaktAuswahlModule,
        BetriebskontaktCardModule,
        GruppeTierModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        AusstallenFrageDialogComponent,
        AusstallenDialogComponent,
        AusstallenEmpfaengerDialogComponent,
        TierlisteSchlachthofAuswahlDialogComponent,
        TierlisteImportierenFrageDialogComponent,
    ],
})
export class AusstallenModule {}
